import React from "react";

const airlineFieldData = () => ({
  inBoundFields: [
    {
      name: "legNo",
      label: "Leg No",
      type: "number",
      placeholder: "Enter leg number",
      required: false,
    },
    {
      name: "origin",
      label: "Origin",
      type: "input",
      placeholder: "Enter origin",
      required: false,
    },
    {
      name: "destination",
      label: "Destination",
      type: "input",
      placeholder: "Enter destination",
      required: false,
    },
    {
      name: "carrier",
      label: "Carrier",
      type: "input",
      placeholder: "Enter carrier code",
      required: false,
    },
    {
      name: "flightNumber",
      label: "Flight Number",
      type: "input",
      placeholder: "Enter flight number",
      required: false,
    },
    {
      name: "departureDate",
      label: "Departure Date",
      type: "date",
      placeholder: "Select departure date",
      required: false,
    },
    {
      name: "departureTime",
      label: "Departure Time",
      type: "time",
      placeholder: "Select departure time",
      required: false,
    },
    {
      name: "arrivalTime",
      label: "Arrival Time",
      type: "time",
      placeholder: "Select arrival time",
      required: false,
    },
  ],
  outBoundFields: [
    {
      name: "legNo",
      label: "Leg No",
      type: "number",
      placeholder: "Enter leg number",
      required: false,
    },
    {
      name: "origin",
      label: "Origin",
      type: "input",
      placeholder: "Enter origin",
      required: false,
    },
    {
      name: "destination",
      label: "Destination",
      type: "input",
      placeholder: "Enter destination",
      required: false,
    },
    {
      name: "carrier",
      label: "Carrier",
      type: "input",
      placeholder: "Enter carrier code",
      required: false,
    },
    {
      name: "flightNumber",
      label: "Flight Number",
      type: "input",
      placeholder: "Enter flight number",
      required: false,
    },
    {
      name: "departureDate",
      label: "Departure Date",
      type: "date",
      placeholder: "Select departure date",
      required: false,
    },
    {
      name: "departureTime",
      label: "Departure Time",
      type: "time",
      placeholder: "Select departure time",
      required: false,
    },
    {
      name: "arrivalTime",
      label: "Arrival Time",
      type: "time",
      placeholder: "Select arrival time",
      required: false,
    },
  ],
  mainFields: [
    {
      name: "searchKey",
      label: "Search Key",
      type: "input",
      placeholder: "Enter search key",
      required: false,
    },
    {
      name: "tripType",
      label: "Trip Type",
      type: "text",
      placeholder: "Select trip type",
      required: false,
    },
    {
      name: "origin",
      label: "Origin",
      type: "input",
      placeholder: "Enter origin",
      required: false,
    },
    {
      name: "destination",
      label: "Destination",
      type: "input",
      placeholder: "Enter destination",
      required: false,
    },
    {
      name: "departureDate",
      label: "Departure Date",
      type: "date",
      placeholder: "Select departure date",
      required: false,
    },
    {
      name: "returnDate",
      label: "Return Date",
      type: "date",
      placeholder: "Select return date",
      required: false,
    },
    {
      name: "totalPrice",
      label: "Total Price",
      type: "number",
      placeholder: "Enter total price",
      required: false,
    },
    {
      name: "currency",
      label: "Currency",
      type: "input",
      placeholder: "Enter currency",
      required: false,
    },
  ],
});

export default airlineFieldData;
